import { snakeCase } from 'lodash'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

import { Field } from './types'

export default function useRequiredUboField() {
  const translate = useTranslate()

  return function requiredField(field: Field) {
    const fieldName = translate(`kyc_form.business.ubo.${snakeCase(field)}.title`)

    return {
      value: true,
      message: translate('errors.blank', { field: fieldName }),
    }
  }
}
